import React from 'react';
import { Tooltip } from 'antd';
import {
  info,
  STATUS_LABEL,
  tripStatusOf,
  fuelToday,
  ago,
  TRIP_META,
  typeIconSVG,
  keyMetric,
  ic,
} from './trackingUtils';

const VehicleTrackingList = ({
  vehicles = [],
  onShowOnMap,
  onOpenHistory,
}) => {
  return (
    <div className="lt-scroll">
      <div className="card">
        <div style={{ overflowX: 'auto' }}>
          <table className="t">
            <thead>
              <tr>
                <th>Vehicle</th>
                <th>Driver</th>
                <th>Status</th>
                <th>Location</th>
                <th>Ignition</th>
                <th>Last GPS update</th>
                <th>Today km · Fuel</th>
                <th>Trip</th>
                <th>Tracker / Device ID</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {vehicles.map((v) => {
                const i = info(v);
                const km = keyMetric(v, i);
                const tripMeta = typeof v.trip === 'string'
                  ? TRIP_META[v.trip]
                  : v.trip
                  ? {
                      origin: v.trip.start_trip?.location || 'Origin',
                      dest: v.trip.end_trip?.location || 'Destination',
                    }
                  : null;
                const f = fuelToday(v);
                const tripSt = tripStatusOf(v);

                return (
                  <tr key={v.reg}>
                    {/* Vehicle */}
                    <td>
                      <span className="vt-cell">
                        <span
                          dangerouslySetInnerHTML={{
                            __html: typeIconSVG(v.type, i.display),
                          }}
                        />
                        <span>
                          <button
                            type="button"
                            className="link reg"
                            onClick={() => onShowOnMap && onShowOnMap(v)}
                          >
                            {v.reg}
                          </button>{' '}
                          <span className={`cat ${v.cat}`}>{v.cat}</span>
                          <div className="muted" style={{ fontSize: '12px' }}>
                            {v.type}
                          </div>
                        </span>
                      </span>
                    </td>

                    {/* Driver */}
                    <td className="wrap" style={{ minWidth: '130px', maxWidth: '170px' }}>
                      <span className="drv-cell">
                        <span
                          className="drv-av"
                          style={{
                            width: '26px',
                            height: '26px',
                            background: '#E4DAFC',
                            fontSize: '11px',
                            display: 'inline-grid',
                            placeItems: 'center',
                            borderRadius: '50%',
                          }}
                        >
                          {v.drv.slice(0, 2).toUpperCase()}
                        </span>
                        <span>
                          {v.drv}
                          {v.phone && (
                            <a
                              className="drv-tel blk"
                              href={`tel:${v.phone.replace(/\s/g, '')}`}
                            >
                              <span dangerouslySetInnerHTML={{ __html: ic('phone', 'width="10" height="10"') }} />
                              <span className="num">{v.phone}</span>
                            </a>
                          )}
                        </span>
                      </span>
                    </td>

                    {/* Status */}
                    <td>
                      <span className={`spill sp-${i.display}`}>
                        <span className="dot" />
                        {STATUS_LABEL[i.display]}
                      </span>
                      <div
                        className="num muted km"
                        style={{ fontSize: '12px', marginTop: '3px' }}
                        dangerouslySetInnerHTML={{ __html: km.html }}
                      />
                    </td>

                    {/* Location */}
                    <td style={{ minWidth: '150px', maxWidth: '240px', fontSize: '12px' }}>
                      <Tooltip
                        title={i.loc}
                        placement="topLeft"
                        mouseEnterDelay={0.1}
                        overlayInnerStyle={{ maxWidth: '340px', fontSize: '12px', lineHeight: '1.4' }}
                      >
                        <div
                          style={{
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            lineHeight: '1.45',
                            maxHeight: '2.9em',
                            wordBreak: 'break-word',
                            cursor: 'help',
                            color: '#2a2b37',
                          }}
                        >
                          {i.loc}
                        </div>
                      </Tooltip>
                    </td>

                    {/* Ignition */}
                    <td>
                      <span
                        className={`badge ${i.ign === 'On' ? 'b-ok' : 'b-neutral'} pill`}
                      >
                        {i.ign}
                      </span>
                    </td>

                    {/* Last GPS */}
                    <td>
                      <span className={`badge ${i.inactive || i.offline ? 'b-inactive' : 'b-ok'}`}>
                        {i.inactive || i.offline ? 'Inactive' : 'Online'}
                      </span>
                      <div className="num muted" style={{ fontSize: '12px' }}>
                        {ago(v.last)}
                      </div>
                    </td>

                    {/* KM & Fuel */}
                    <td className="num">
                      {Math.round(v.km || 0)} km
                      <div className="muted" style={{ fontSize: '12px' }}>
                        {f.total.toFixed(1)} L est.
                      </div>
                    </td>

                    {/* Trip */}
                    <td className="gfc wrap" style={{ minWidth: '150px', maxWidth: '210px' }}>
                      {v.trip ? (
                        <div>
                          <div style={{ fontSize: '12px', marginBottom: '2px', fontWeight: 600 }}>
                            {typeof v.trip === 'object' ? (v.trip.trip_id || `TRIP-${v.trip.id}`) : v.trip}
                          </div>
                          <span className={`badge b-low pill`}>{tripSt}</span>
                          {tripMeta && (
                            <div className="muted" style={{ fontSize: '11.5px', marginTop: '2px' }}>
                              {tripMeta.origin.split(',')[0]} → {tripMeta.dest.split(',')[0]}
                            </div>
                          )}
                        </div>
                      ) : (
                        <span className="faint">Awaiting for Trip</span>
                      )}
                    </td>

                    {/* Tracker IMEI */}
                    <td>
                      Trackingplus
                      <div className="mono muted" style={{ fontSize: '11.5px' }}>
                        {v.dev}
                      </div>
                    </td>

                    {/* Actions */}
                    <td>
                      <div className="row-actions">
                        <button
                          type="button"
                          className="icon-btn"
                          title="Show on map"
                          onClick={() => onShowOnMap && onShowOnMap(v)}
                          dangerouslySetInnerHTML={{ __html: ic('map') }}
                        />
                        <button
                          type="button"
                          className="icon-btn"
                          title="View history"
                          onClick={() => onOpenHistory && onOpenHistory(v.reg)}
                          dangerouslySetInnerHTML={{ __html: ic('history') }}
                        />
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="t-foot">
          Positions refresh every 5s · inactive rows show the last known location
        </div>
      </div>
    </div>
  );
};

export default VehicleTrackingList;
